module.exports = __webpack_public_path__ + "media/images/doctor-8c3f09b75c33703fcfdee130376728c2.svg";